import React, { Fragment, useCallback, useRef } from 'react';
import { CarouselImage } from 'components';
import { useEvent } from 'helpers';
import css from './background.scss';

export function Background(props) {
  const carousel = useRef();

  useEvent('scroll', () => {
    if (!props.visible.Middle) {
      if (!carousel.current.raf && !props.status) {
        carousel.current.scrolled = window.pageYOffset;
        carousel.current.raf = requestAnimationFrame(tick);
      }
    }
  });

  const tick = useCallback(() => {
    carousel.current.raf = false;
    carousel.current.style.transform = `translate3d(0,0,0) scale(1.15) translateY(${carousel.current.scrolled*-0.2}px)`;
  }, []);

  return (
    <Fragment>
      <div ref={carousel} className={css('photoContainer', props.status)}>
        <CarouselImage>
          { props.images.slice(props.current, props.current + 1) }
        </CarouselImage>
      </div>
      <svg className={css.svg} viewBox="0 0 100 100" preserveAspectRatio="none">
        <path className={[css.intro, props.visible.Intro && css.visible].join(' ')} d="M0 0h100v100H0z"/>
        <path className={[css.middle, props.visible.Middle && css.visible, props.visible.Apps && css.stretch].join(' ')} d="M0 0h100v100H0z"/>
        <path className={[css.reviews, props.visible.Reviews && css.visible].join(' ')} d="M0 0h100v100H0z"/>
        <path className={[css.bottom, props.visible.Bottom && css.visible].join(' ')} d="M0 0h100v100H0z"/>
      </svg>
    </Fragment>
  );
}
